module.exports = __webpack_public_path__ + "media/assets/ManageAccess-57908283a6e00aff363606641392d9a9.svg";